import React, { useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { ChevronDownIcon, MenuIcon, XIcon } from 'lucide-react';
import { services } from '../data/services';
import { company } from '../data/company';
export function Header() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [servicesOpen, setServicesOpen] = useState(false);
  const location = useLocation();
  React.useEffect(() => {
    setMobileOpen(false);
    setServicesOpen(false);
  }, [location.pathname]);
  const navLinkClass = ({
    isActive
  }: {
    isActive: boolean;
  }) => `text-[15px] transition-colors duration-150 ease-out ${isActive ? 'text-navy-900 font-medium' : 'text-ink/80 hover:text-navy-900'}`;
  return <header className="w-full" data-id="element-76" data-mp="369qnvuv1fdq3">
      <div className="bg-navy-950 text-white/80" data-id="element-77" data-mp="36cwbf5o0q7jp">
        <div className="mx-auto flex max-w-shell items-center justify-between gap-4 px-6 py-2.5 text-[13px]" data-id="element-78" data-mp="3bb651bu3h037">
          <p className="font-medium" data-id="element-79" data-mp="3fcjedvweblev">
            Professional fiduciary, trust, estate and care administration services
          </p>
          <Link to="/contact" className="hidden shrink-0 transition-colors duration-150 ease-out hover:text-white sm:block" data-id="element-80" data-mp="2wihxtxyo4ak9">
            Speak with <span className="text-gold" data-id="element-81" data-mp="2mn6qi0pla5mj">our team</span>
          </Link>
        </div>
      </div>

      <div className="border-b border-slate-200 bg-white" data-id="element-82" data-mp="2hp4xoo2d2rxv">
        <div className="mx-auto flex max-w-shell items-center justify-between px-6 py-4" data-id="element-83" data-mp="3fbvjfcghr4n7">
          <Link to="/" className="flex items-center" aria-label={`${company.name} — home`} data-id="element-84" data-mp="3acj1n64h8nrh">
            <img src={company.logoUrl} alt={company.name} className="h-12 w-auto sm:h-14" data-id="element-85" data-mp="35l9bm4f0nif2" />
          </Link>

          <nav className="hidden items-center gap-8 lg:flex" aria-label="Main" data-id="element-86" data-mp="30m66kjz1dc73">
            <NavLink to="/" className={navLinkClass} end data-id="element-87" data-mp="1x7mu3fkuipq">
              Home
            </NavLink>
            <NavLink to="/about" className={navLinkClass} data-id="element-88" data-mp="3tabsvb5qn991">
              About Us
            </NavLink>
            <div className="relative" onMouseEnter={() => setServicesOpen(true)} onMouseLeave={() => setServicesOpen(false)} data-id="element-89" data-mp="1re37rzvz30hz">
              <NavLink to="/services" className={navLinkClass} data-id="element-90" data-mp="1hmqgpai00ed0">
                <span className="flex items-center gap-1.5" data-id="element-91" data-mp="1mml619m4kvvy">
                  Fiduciary Services
                  <ChevronDownIcon className="h-4 w-4" aria-hidden="true" data-id="element-92" data-mp="18nbpu9xx61rz" />
                </span>
              </NavLink>
              {servicesOpen && <div className="absolute left-1/2 top-full z-20 w-[320px] -translate-x-1/2 pt-4" data-id="element-93" data-mp="1cq8cqcuhsk1q">
                  <ul className="border border-slate-200 bg-white py-2 shadow-lg" data-id="element-94" data-mp="yqgtnxp4cdgv">
                    {services.map(service => <li key={service.slug} data-id="element-95" data-mp="2t2x7bjk8utvr">
                        <Link to={`/services/${service.slug}`} className="block px-5 py-2.5 text-[14px] text-ink/80 transition-colors duration-150 ease-out hover:bg-mist hover:text-navy-900" data-id="element-96" data-mp="2t48api9s1zmc">
                          {service.title}
                        </Link>
                      </li>)}
                  </ul>
                </div>}
            </div>
            <NavLink to="/contact" className={navLinkClass} data-id="element-97" data-mp="re12ihqry11q">
              Contact Us
            </NavLink>
            <Link to="/contact" className="bg-navy-900 px-6 py-3 text-[15px] font-medium text-white transition-colors duration-150 ease-out hover:bg-navy-800" data-id="element-98" data-mp="154mmk9rysh17">
              Request a Consultation
            </Link>
          </nav>

          <button type="button" onClick={() => setMobileOpen(open => !open)} className="text-navy-900 lg:hidden" aria-expanded={mobileOpen} aria-label={mobileOpen ? 'Close menu' : 'Open menu'} data-id="element-99" data-mp="1a4924pv9m9d6">
            {mobileOpen ? <XIcon className="h-6 w-6" data-id="element-100" data-mp="3bxoubr703wa9" /> : <MenuIcon className="h-6 w-6" data-id="element-101" data-mp="22yxdbf67dcmm" />}
          </button>
        </div>

        {mobileOpen && <div className="border-t border-slate-200 bg-white lg:hidden" data-id="element-102" data-mp="27x8p3vg25x7h">
            <nav className="mx-auto max-w-shell px-6 py-4" aria-label="Mobile" data-id="element-103" data-mp="27zl6a6dzs3jh">
              <ul className="space-y-1" data-id="element-104" data-mp="2cxmjwbsnfank">
                <li data-id="element-105" data-mp="2gyyfqz248s47">
                  <Link to="/" className="block py-2.5 text-ink/85" data-id="element-106" data-mp="2gxexj2wwg6zs">
                    Home
                  </Link>
                </li>
                <li data-id="element-107" data-mp="1k62yqmchrmix">
                  <Link to="/about" className="block py-2.5 text-ink/85" data-id="element-108" data-mp="1p7a82pua8trp">
                    About Us
                  </Link>
                </li>
                <li data-id="element-109" data-mp="1t82gxhz8swng">
                  <Link to="/services" className="block py-2.5 text-ink/85" data-id="element-110" data-mp="1t7kjwj4raeeh">
                    Fiduciary Services
                  </Link>
                </li>
                <li className="border-l border-slate-200 pl-4" data-id="element-111" data-mp="11gmvvsdc3hzc">
                  <ul data-id="element-112" data-mp="15j9rm4d4ln1t">
                    {services.map(service => <li key={service.slug} data-id="element-113" data-mp="15h6t0vxwqllh">
                        <Link to={`/services/${service.slug}`} className="block py-2 text-[14px] text-ink/70" data-id="element-114" data-mp="y00imc8j7qda">
                          {service.title}
                        </Link>
                      </li>)}
                  </ul>
                </li>
                <li data-id="element-115" data-mp="k23khbefjbwi">
                  <Link to="/contact" className="block py-2.5 text-ink/85" data-id="element-116" data-mp="f0wcpccaecpu">
                    Contact Us
                  </Link>
                </li>
              </ul>
              <Link to="/contact" className="mt-4 block bg-navy-900 px-6 py-3 text-center text-[15px] font-medium text-white" data-id="element-117" data-mp="a8v4c1i8p653">
                Request a Consultation
              </Link>
            </nav>
          </div>}
      </div>
    </header>;
}